import React from "react";
import { ReactComponent as DEFlag } from "../assets/flags/de.svg";
import { ReactComponent as ENFlag } from "../assets/flags/en.svg";
import { ReactComponent as FRFlag } from "../assets/flags/fr.svg";
import { ReactComponent as NLFlag } from "../assets/flags/nl.svg";
import { ReactComponent as PLFlag } from "../assets/flags/pl.svg";
import { ReactComponent as RUFlag } from "../assets/flags/ru.svg";

export type SystemLocale = "en" | "de" | "fr" | "ru" | "pl" | "nl";
export type Locale = "en-GB" | "de" | "fr" | "ru" | "pl" | "nl";

export const defaultLocale: Locale = "en-GB";

export interface Language {
  locale: Locale;
  name_key: string;
  language_name: string;
  flag: React.ElementType;
  countryCode: string;
  countryName: string;
}

export const languages: Record<Locale, Language> = {
  "en-GB": {
    name_key: "gb",
    locale: "en-GB",
    language_name: "English",
    flag: ENFlag,
    countryCode: "GBR",
    countryName: "Great Britain",
  },
  de: {
    name_key: "de",
    locale: "de",
    language_name: "Deutsch",
    flag: DEFlag,
    countryCode: "DEU",
    countryName: "Germany",
  },
  fr: {
    name_key: "fr",
    locale: "fr",
    language_name: "Français",
    flag: FRFlag,
    countryCode: "FRA",
    countryName: "France",
  },
  nl: {
    name_key: "nl",
    locale: "nl",
    language_name: "Dutch",
    flag: NLFlag,
    countryCode: "NLD",
    countryName: "Netherlands",
  },
  pl: {
    name_key: "pl",
    locale: "pl",
    language_name: "Polski",
    flag: PLFlag,
    countryCode: "POL",
    countryName: "Poland",
  },
  ru: {
    name_key: "ru",
    locale: "ru",
    language_name: "Pyccкий",
    flag: RUFlag,
    countryCode: "RUS",
    countryName: "Russia",
  },
};

export const getSupportedSystemLocalCode = (
  localeOrSubLocale: string
): SystemLocale => {
  const localCode = localeOrSubLocale.split(/[-_]/)[0];
  if (["en", "de", "fr", "ru", "pl", "nl"].includes(localCode))
    return localCode as SystemLocale;
  // nothing found
  return "en";
};

export const getSupportedSystemLocale = (localeOrSubLocale: string): Locale => {
  const localeCode = getSupportedSystemLocalCode(localeOrSubLocale);

  if (localeCode === "en") return "en-GB";
  if (localeCode === "de") return "de";
  if (localeCode === "fr") return "fr";
  if (localeCode === "ru") return "ru";
  if (localeCode === "pl") return "pl";
  if (localeCode === "nl") return "nl";

  // nothing found
  return defaultLocale;
};
